import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Tooltip from '../Tooltip';

class FloatingButton extends Component {
  constructor() {
    super();

    this.state = {
      toggled: false
    };
  }


  handleOnClick() {
    const { children, onClick } = this.props;
    const { toggled } = this.state;

    if (children) {
      this.setState({ toggled: !toggled });
    } else {
      onClick();
    }
  }


  render() {
    const { toggled } = this.state;
    const { className, type, size, tooltipText, children, iconName } = this.props;
    const mainClassName = classNames('floating-menu', { open: toggled });
    const opacityClassName = classNames('floating-menu-opacity', { active: toggled });
    const classes = classNames('floating-button', 'floating-menu-icon', `btn-${type}`, className, `floating-${size}`);
    const icon = toggled ? 'times' : iconName;

    return (
      <Fragment>
        <div className={opacityClassName} />
        <div className={mainClassName}>
          { toggled && children }
          <div className="floating-menu-item">
            <button type="button" className={classes} onClick={this.handleOnClick.bind(this)} data-tip data-for="floating-button">
              <span className="button-icon">
                <FontAwesomeIcon icon={{ prefix: 'fal', iconName: icon }} size="2x" />
              </span>
            </button>
          </div>
          {
            tooltipText && (
              <Tooltip id="floating-button">
                {tooltipText}
              </Tooltip>
            )
          }
        </div>
      </Fragment>

    );
  }
}


FloatingButton.defaultProps = {
  type: 'dark',
  size: 'medium',
  iconName: 'plus'
};

FloatingButton.propTypes = {
  type: PropTypes.oneOf(['warning', 'danger', 'success', 'primary', 'info', 'dark', 'secondary', 'green']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  iconName: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  tooltipText: PropTypes.string,
};


export default FloatingButton;
